import { useState } from "react";

function useFileReader() {
  const [progress, setProgress] = useState(0);

  const readProgress = async (file, chunkSize = 1024 * 1024) => {
    let offset = 0;
    const total = file.size;
    const chunks = [];

    while (offset < total) {
      const slice = file.slice(offset, offset + chunkSize);
      const buffer = await slice.arrayBuffer();
      chunks.push(buffer);
      offset += chunkSize;

      const currentProgress = Math.round((offset / total) * 100);
      setProgress(currentProgress);

      await new Promise((resolve) => setTimeout(resolve, 50));
    }

    setProgress(100);

    return chunks;
  };

  const resetProgress = () => {
    setProgress(0);
  };

  return {
    progress,
    readProgress,
    resetProgress,
  };
}

export default useFileReader;
